import React, { useEffect, useRef } from 'react';

const TableTextAreaField = ({
  value,
  onChange,
  onKeyDown = () => {},
  onBlur,
  onFocus,
  className = '',
  id = '',
  style,
  readOnly = false
}) => {
  const textAreaRef = useRef(null);

  useEffect(() => {
    if (textAreaRef.current) {
      // Reseting height before recalculating to avoid infinite growth
      textAreaRef.current.style.height = 'auto';
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
    }
  }, [value]);

  return (
    <textarea
      ref={textAreaRef}
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`px-2 py-1 bg-[#292A3580] border border-input-border resize-none rounded outline-none focus:border-input-focus focus:ring-1 focus:ring-input-focus/30 transition-colors duration-150 ${className}`}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      onBlur={onBlur}
      id={id}
      title={value}
      style={style}
      cols={84}
      readOnly={readOnly}
    />
  );
};

export default TableTextAreaField;
